import { render, staticRenderFns } from "./CheckPage.vue?vue&type=template&id=2e8620ec&scoped=true&"
import script from "./CheckPage.vue?vue&type=script&lang=js&"
export * from "./CheckPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8620ec",
  null
  
)

export default component.exports